import PodcastList from './PodcastList';
import PodcastEdit from './PodcastEdit';
import PodcastCreate from "./PodcastCreate";

export default {
    list: PodcastList,
    edit: PodcastEdit,
    create: PodcastCreate,
};
